export default {"src":"https://marketplace-web-assets.vinted.com/_next/static/media/logo.f29f72cb.svg","height":48,"width":83,"blurWidth":0,"blurHeight":0};